module.exports = "/images/veil-3.jpg";